"use strict";
var __extends =
  (this && this.__extends) ||
  (function() {
    var extendStatics = function(d, b) {
      extendStatics =
        Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array &&
          function(d, b) {
            d.__proto__ = b;
          }) ||
        function(d, b) {
          for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        };
      return extendStatics(d, b);
    };
    return function(d, b) {
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype =
        b === null
          ? Object.create(b)
          : ((__.prototype = b.prototype), new __());
    };
  })();
var __importDefault =
  (this && this.__importDefault) ||
  function(mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
var BaseFile_1 = __importDefault(
  require("@ilovepdf/ilovepdf-js-core/tasks/BaseFile")
);
var ILovePDFFile = /** @class */ (function(_super) {
  __extends(ILovePDFFile, _super);
  function ILovePDFFile(file, taskId, params) {
    var _this = this;
    var filename = file.name;
    _this = new BaseFile_1.default(taskId, "", filename, params) || this;
    // Keep data.
    _this.file = file;
    return _this;
  }
  Object.defineProperty(ILovePDFFile.prototype, "data", {
    get: function() {
      // Create each time due to 'task'
      // property could change previously.
      var formData = new FormData();
      formData.append("task", this.taskId);
      formData.append("file", this.file);
      return formData;
    },
    enumerable: false,
    configurable: true
  });
  return ILovePDFFile;
})(BaseFile_1.default);
exports.default = ILovePDFFile;
//# sourceMappingURL=ILovePDFFile.js.map
